var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "533 3495.801 100 100.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #b8bdc1;\n      }\n\n      .cls-3 {\n        fill: #e6e7e8;\n      }\n\n      .cls-4 {\n        fill: #cc4b4c;\n      }\n\n      .cls-5 {\n        fill: #f0ce49;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(414 2325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    className: "cls-1",
    d: "M50,0A50,50,0,1,1,0,50,50,50,0,0,1,50,0Z",
    transform: "translate(119 1171)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(78.911 1170.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    className: "cls-2",
    d: "M123.281,118.716H56.162a3.2,3.2,0,0,1-3.2-3.2v-6.392a3.2,3.2,0,0,1,3.2-3.2h67.119a3.2,3.2,0,0,1,3.2,3.2v6.392a3.2,3.2,0,0,1-3.2,3.2",
    transform: "translate(0 -86.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    className: "cls-3",
    d: "M76.506,176.552l6.936,57.8a3.2,3.2,0,0,0,3.185,2.931h44.746a3.2,3.2,0,0,0,3.185-2.931l6.937-57.8Z",
    transform: "translate(-19.278 -144.59)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(57.777 8.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    className: "cls-4",
    d: "M108.25,62.554l-1.691-9.588-27.017,5.2.775,4.39Z",
    transform: "translate(-79.542 -51.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    className: "cls-4",
    d: "M319.7,56.56l1.338-7.583-20.775-3.33L298.34,56.56Z",
    transform: "translate(-258.73 -45.647)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    className: "cls-5",
    d: "M199.281,0,167.23,2.728l.94,8.825,10.2-1.964,1.691,9.588h10.9l1.924-10.913,7.388,1.184Z",
    transform: "translate(-93.579)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(63.298 39.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    className: "cls-2",
    d: "M114.087,454.164h44.746a3.2,3.2,0,0,0,3.185-2.931l.866-9.854H110.036l.866,9.854a3.2,3.2,0,0,0,3.185,2.931",
    transform: "translate(-110.036 -401.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    className: "cls-2",
    d: "M248.77,252.651a1.6,1.6,0,0,1-1.6-1.6V222.287a1.6,1.6,0,0,1,3.2,0v28.765a1.6,1.6,0,0,1-1.6,1.6",
    transform: "translate(-222.346 -220.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    className: "cls-2",
    d: "M156.08,252.839a1.6,1.6,0,0,1-1.59-1.459l-2.506-28.657a1.6,1.6,0,0,1,3.183-.278l2.506,28.657a1.6,1.6,0,0,1-1.453,1.731,1.315,1.315,0,0,1-.141.007",
    transform: "translate(-144.385 -220.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    className: "cls-2",
    d: "M330.126,252.839c-.046,0-.094,0-.141-.006a1.6,1.6,0,0,1-1.453-1.731l2.506-28.657a1.6,1.6,0,0,1,3.183.278l-2.506,28.657a1.6,1.6,0,0,1-1.59,1.459",
    transform: "translate(-288.973 -220.932)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.8ee28eb60ca4ac07ec5318b6ae207e61.svg";
export { ForwardRef as ReactComponent };